import type { ReactElement, ReactNode } from 'react';

import ListButton from '@/ui/components/list-button';

export type RenderItemFn<I> = (item: I) => ReactNode;

type ItemProps<I> = {
  item: I;
  renderItem: RenderItemFn<I>;
  onClick?: ((item: I) => void) | null;
};

function Item<I>({ item, renderItem, onClick }: ItemProps<I>): ReactElement {
  return onClick ? (
    <ListButton
      onClick={() => onClick(item)}
      dataTestId="scrollable-list-item-button"
    >
      {renderItem(item)}
    </ListButton>
  ) : (
    <>{renderItem(item)}</>
  );
}

export default Item;
